import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';

//获得委托方
export async function getConsignorForOemTask(params) {
    return post(erpserver+'/scorder/getConsignorForOemTask', params, true)
}
//获得自产/代加工
export async function getScorderList(params) {
    return post(erpserver+'/scorder/getScorderList', params, true)
}
//获取仓库
export async function getWarehouseList(params) {
    return post(erpserver+'/currency/getWarehouseList', params, true)
}
// 获取申请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取领用部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 获取产品
export async function getScorderPzList(params) {
    return post(erpserver+'/scorder/getScorderPzList', params, true);
}
// 保存生产任务
export async function saveScorder(params) {
    return post(erpserver+'/scorder/saveScorder', params, true);
}
// 查看生产任务
export async function getScorder(params) {
    return post(erpserver+'/scorder/getScorder', params, true);
}
//查询开票方（客户
export async function getkhlist(params) {
    return post(erpserver+'/currency/getkhlist', params, true);
}
